export default "__VITE_ASSET__DJnOJsfu__"